import React, { Component } from 'react';
import '../css/dakehu.css';
import {withRouter,Link} from 'react-router-dom';
import phone from '../util/phone';
import { connect } from 'react-redux';
class Dakehueight extends Component{
    state={
        dakehuonem:'none',
        videoone:['https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/8/1.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/8/2.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/8/3.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/8/4.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/8/5.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/8/6.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/8/7.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/8/8.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/8/9.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/8/10.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/8/11.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/8/12.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/8/13.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/8/14.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/8/15.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/8/16.mp4'],
        videos:'',
        dakehusis:'block',
        dakehusixns:'none',
        shenqing:'none'
    }
     panduan(videonum){
        if(phone.indexOf(this.props.userInfo.userInfo.phone)==-1){
            this.setState({
                shenqing:'block'
            })
            return -1;
        }else{
            console.log('成功')
            this.setState({
                dakehuonem:'block',
                videos:videonum
            });
            return 2;
        }
    }
    firstm(){
        var videonum=this.state.videoone[0];
        this.panduan(videonum);
    }
    secondm(){
        var videonum=this.state.videoone[1];
        this.panduan(videonum);
    }
    thirdm(){
        var videonum=this.state.videoone[2];
        this.panduan(videonum);
    }
    fourm(){
        var videonum=this.state.videoone[3];
        this.panduan(videonum);
    }
    fivem(){
        var videonum=this.state.videoone[4];
        this.panduan(videonum);
    }
    sixm(){
        var videonum=this.state.videoone[5];
        this.panduan(videonum);
    }
    sevenm(){
        var videonum=this.state.videoone[6];
        this.panduan(videonum);
    }
    eightm(){
        var videonum=this.state.videoone[7];
        this.panduan(videonum);
    }
    ninem(){
       var videonum=this.state.videoone[8];
        this.panduan(videonum);
    }
    shim(){
        var videonum=this.state.videoone[9];
        this.panduan(videonum);
    }
    shiyim(){
       var videonum=this.state.videoone[10];
        this.panduan(videonum);
    }
    shierm(){
        var videonum=this.state.videoone[0];
        this.panduan(videonum);
    }
    shisanm(){
        var videonum=this.state.videoone[11];
        this.panduan(videonum);
    }
    shisim(){
        var videonum=this.state.videoone[12];
        this.panduan(videonum);
    }
    shiwum(){
        var videonum=this.state.videoone[13];
        this.panduan(videonum);
    }
    shilium(){
        var videonum=this.state.videoone[14];
        this.panduan(videonum);
    }
    closes(){
        var dakehuvideo=document.getElementById('dakehuvideo1');
        dakehuvideo.pause();
        this.setState({
            dakehuonem:'none'
        });
    }

    dakehueightnext(){
        var that=this;
        that.setState({
            dakehueightbac:'url("https://weixun-demo.oss-cn-beijing.aliyuncs.com/dakehu/dakehueighteight.jpg")',
            dakehueightns:'block',
            dakehueigh:'none'
        });
    }
    dakehueightback(){
        var that=this;
        that.setState({
            dakehueightbac:'url("https://weixun-demo.oss-cn-beijing.aliyuncs.com/dakehu/dakehueight.jpg")',
            dakehueigh:'block',
            dakehueightns:'none'
        });
    }
    componentDidMount() {
        var dakehuvideo = document.getElementById('dakehuvideo1');
        var that=this;
        dakehuvideo.addEventListener('ended', function () {
            for(var i=0;i<that.state.videoone.length;i++){
                if(that.state.videos==that.state.videoone[i]){
                    if(that.state.wancheng.indexOf(i)!=-1){
                        console.log('包含');
                    }else{
                        that.setState({
                            wancheng:that.state.wancheng+i
                        })
                    }
                    console.log(that.state.wancheng);
                }

            }
        });
        dakehuvideo.addEventListener("timeupdate",function(){
            var timeDisplay;
            timeDisplay = Math.floor(dakehuvideo.currentTime);
        },true)
    }
    render(){
        return(
            <div className='dakehueightbac' style={{backgroundImage:this.state.dakehueightbac}}>
                <Link to='dakehu'><div className='dakehutui'></div></Link>
                <div className='dakehueightcourseyi' onClick={this.firstm.bind(this)} style={{display:this.state.dakehueigh}}></div>
                <div className='dakehueightcourseer' onClick={this.secondm.bind(this)} style={{display:this.state.dakehueigh}}></div>
                <div className='dakehueightcoursesan' onClick={this.thirdm.bind(this)} style={{display:this.state.dakehueigh}}></div>
                <div className='dakehueightcoursesi' onClick={this.fourm.bind(this)} style={{display:this.state.dakehueigh}}></div>
                <div className='dakehueightcoursewu' onClick={this.fivem.bind(this)} style={{display:this.state.dakehueigh}}></div>
                <div className='dakehueightcourseliu' onClick={this.sixm.bind(this)} style={{display:this.state.dakehueigh}}></div>
                <div className='dakehueightcourseqi' onClick={this.sevenm.bind(this)} style={{display:this.state.dakehueigh}}></div>
                <div className='dakehueightcourseba' onClick={this.eightm.bind(this)} style={{display:this.state.dakehueigh}}></div>
                <div className='dakehusevennext' onClick={this.dakehueightnext.bind(this)} style={{display:this.state.dakehueigh}}></div>
                <div className='dakehueightcoursejiu' onClick={this.ninem.bind(this)} style={{display:this.state.dakehueightns}}></div>
                <div className='dakehueightcourseshi' onClick={this.shim.bind(this)} style={{display:this.state.dakehueightns}}></div>
                <div className='dakehueightcourseshiyi' onClick={this.shiyim.bind(this)} style={{display:this.state.dakehueightns}}></div>
                <div className='dakehueightcourseshier' onClick={this.shierm.bind(this)} style={{display:this.state.dakehueightns}}></div>
                <div className='dakehueightcourseshisan' onClick={this.shisanm.bind(this)} style={{display:this.state.dakehueightns}}></div>
                <div className='dakehueightcourseshisi' onClick={this.shisim.bind(this)} style={{display:this.state.dakehueightns}}></div>
                <div className='dakehueightcourseshiwu' onClick={this.shiwum.bind(this)} style={{display:this.state.dakehueightns}}></div>
                <div className='dakehueightcourseshiliu' onClick={this.shilium.bind(this)} style={{display:this.state.dakehueightns}}></div>
                <div className='dakehusevenback' onClick={this.dakehueightback.bind(this)} style={{display:this.state.dakehueightns}}></div>
                <div className='dakehushenqing' style={{display:this.state.shenqing}} ></div>
                <video className='dakehuvideo1' id='dakehuvideo1'  style={{display:this.state.dakehuonem}} controls='controls'  autoPlay='true' src={this.state.videos}/>
                <div className='dakehuclose' onClick={this.closes.bind(this)} style={{display:this.state.dakehuonem}}>X</div>
            </div>

        )
    }
}

function mapStateToProps({ login}/*默认值加解构数组*/) {

    console.log(login)
    return {
        userInfo: login

    }
}

export default withRouter(connect(mapStateToProps)(Dakehueight));
